import { boolean, object, string } from 'yup'

const FleetNewsletterSchema = object().shape({
  title: string()
    .required('Title is required')
    .min(1, 'Title must be at least 2 characters')
    .max(10, 'Title must be at most 10 characters')
    .trim(),
  first_name: string()
    .required('First name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'First name can only contain letters and basic punctuation',
    )
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .trim(),
  last_name: string()
    .required('Last name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'Last name can only contain letters and basic punctuation',
    )
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .trim(),
  company_name: string()
    .matches(
      /^[A-Za-z-.,'` ]{0,100}$/,
      'Company name can only contain letters and basic punctuation',
    )
    .max(100, 'Company name must be at most 100 characters')
    .required('Company name is required')
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(100)
    .trim(),
  postcode: string()
    .required('Postcode is required')
    .matches(
      /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/,
      'Postcode must be a valid UK postcode',
    )
    .trim(),
  consent: boolean(),
})

export default FleetNewsletterSchema
